import { createSelector } from '@reduxjs/toolkit';

import { userSelector } from '@lootboy/lib/selectors';
import { TUser } from '@lootboy/lib/types/user';

type TSocialProfile = {
  username?: string;
  _json?: {
    nickname?: string;
    personaname: string;
  };
};

type TSocialUser = TUser & {
  googleProfile?: TSocialProfile;
  facebookProfile?: TSocialProfile;
  twitterProfile?: TSocialProfile;
  steamProfile?: TSocialProfile;
  twitchProfile?: TSocialProfile;
  instagramProfile?: TSocialProfile;
};

export const usernameSelector = createSelector(
  userSelector,
  (user: TSocialUser) => {
    if (user.username) {
      return user.username;
    }

    const profile =
      user.googleProfile ||
      user.facebookProfile ||
      user.twitterProfile ||
      user.steamProfile ||
      user.twitchProfile ||
      user.instagramProfile;
    return (
      profile &&
      (profile.username ||
        // eslint-disable-next-line no-underscore-dangle
        profile._json?.nickname ||
        // eslint-disable-next-line no-underscore-dangle
        profile._json?.personaname)
    );
  },
);

export const userDetailsSelector = createSelector(
  userSelector,
  usernameSelector,
  (user: TUser, username) => {
    const { country, birthday, gender } = user;
    return { username, country, birthday, gender };
  },
);

export const userRecruitedSelector = createSelector(
  userSelector,
  (user) => !!user.recruiter,
);

export const userHasPasswordSelector = createSelector(
  userSelector,
  (user: TUser) => !!user.passwordHash,
);
